/* ============================================================
   CART DRAWER — the receipt printer
   On load this rebuilds #cartDrawer (markup lives in theme.liquid)
   into a receipt printer: a printer head at the top and a paper slip
   that feeds out of its slot every time the bag opens, then gets an
   "Awaiting payment" stamp. The ids the rest of the theme uses
   (drawerItems, drawerSubtotal, drawerCount, drawerFooter,
   drawerEmpty) are kept, so refreshCartCount() and every
   openCartDrawer() / closeCartDrawer() call keep working.
   Quantity changes patch figures in place; nothing reprints.
   Styles: assets/urbanleb-cart.css
   ============================================================ */
(function () {
  'use strict';
  var money = function (c) { return '$' + ((c || 0) / 100).toFixed(2); };
  var state = { items: [], inflight: {}, want: {}, unit: {}, token: '' };
  var MON = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var printT = null;
  /* the wax-seal logo sits next to this script in the theme's assets */
  var SEAL = (function () { var s = document.currentScript || document.querySelector('script[src*="urbanleb-cart.js"]'); return s && s.src ? s.src.replace(/urbanleb-cart\.js.*$/, 'urbanleb-seal.webp') : ''; })();

  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function when(d) { return pad(d.getDate()) + ' ' + MON[d.getMonth()] + ' ' + d.getFullYear() + ' · ' + pad(d.getHours()) + ':' + pad(d.getMinutes()); }
  function hash(s) { var h = 2166136261 >>> 0; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; } return h >>> 0; }
  function rnd(h) { return (Math.imul(h, 1664525) + 1013904223) >>> 0; }
  function digits(h) { var s = ''; for (var i = 0; i < 15; i++) { h = rnd(h); s += String((h >>> 16) % 10); } return s.slice(0, 7) + ' ' + s.slice(7, 11) + ' ' + s.slice(11); }
  function bars(h) {
    var W = 210, H = 46, x = 7, on = true, r = '<rect x="0" width="2" height="46"/><rect x="4" width="1" height="46"/>';
    while (x < W - 9) { h = rnd(h); var w = 1 + ((h >>> 24) % 3); if (on) r += '<rect x="' + x + '" width="' + w + '" height="' + H + '"/>'; x += w; on = !on; }
    r += '<rect x="' + (W - 5) + '" width="1" height="46"/><rect x="' + (W - 2) + '" width="2" height="46"/>';
    return '<svg class="rc-bars" viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none" aria-hidden="true" fill="currentColor">' + r + '</svg>';
  }

  /* receipt mono */
  (function () {
    if ($('rcFont')) return;
    var l = document.createElement('link'); l.id = 'rcFont'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500;700;800&display=swap';
    document.head.appendChild(l);
  })();

  function shell(action) {
    return ''
      + '<div class="rc-head">'
      +   '<div class="rc-bar"><span class="rc-label">Your bag</span>'
      +   '<button type="button" class="rc-x" onclick="closeCartDrawer()" aria-label="Close bag">✕</button></div>'
      +   '<div class="rc-printer" aria-hidden="true"><span class="rc-led"></span><span class="rc-slot"></span></div>'
      + '</div>'
      + '<div class="rc-scroll" id="rcScroll">'
      +  '<div class="rc-feed">'
      +   '<div class="rc-paper" id="rcPaper">'
      +    '<div class="rc-top">'
      +     (SEAL ? '<img class="rc-seal" src="' + esc(SEAL) + '" width="257" height="260" alt="Urban.Leb" '
      +       'style="display:block;width:122px;height:auto;margin:-8px auto 2px;transform:rotate(-7deg);'
      +       'filter:drop-shadow(0 7px 9px rgba(38,33,27,.26)) drop-shadow(0 1px 1px rgba(38,33,27,.35))">'
              : '<h2 class="rc-brand">Urban.Leb</h2>')
      +     '<div class="rc-sub">Official store · urbanleb.com</div>'
      +    '</div>'
      +    '<dl class="rc-meta">'
      +     '<div><dt>Order</dt><dd id="rcOrder">#UL-000000</dd></div>'
      +     '<div><dt>Date</dt><dd id="rcDate">' + when(new Date()) + '</dd></div>'
      +     '<div><dt>Cashier</dt><dd>Urban.Leb · hand checked</dd></div>'
      +     '<div><dt>Pay by</dt><dd>Cash on delivery / Visa</dd></div>'
      +     '<div><dt>Items</dt><dd id="drawerCount">0</dd></div>'
      +    '</dl>'
      +    '<div class="rc-rule"></div>'
      +    '<div class="rc-cols"><span>Qty · Item</span><span>Amount</span></div>'
      +    '<div class="rc-items" id="drawerItems"></div>'
      +    '<div class="rc-empty" id="drawerEmpty">'
      +     '<p class="rc-empty-t">No items on this receipt</p>'
      +     '<p class="rc-empty-s">Your bag is empty — nothing printed yet.</p>'
      +     '<button type="button" class="rc-shop" onclick="closeCartDrawer()">Start shopping →</button>'
      +    '</div>'
      +    '<div class="rc-sum">'
      +     '<div class="rc-rule"></div>'
      +     '<div class="rc-row"><span>Subtotal</span><span id="drawerSubtotal">$0.00</span></div>'
      +     '<div class="rc-row"><span>Shipping · Lebanon</span><span>FREE</span></div>'
      +     '<div class="rc-row"><span>Cash on delivery fee</span><span>$0.00</span></div>'
      +     '<div class="rc-total">'
      +      '<span class="rc-stamp" aria-hidden="true">Awaiting payment</span>'
      +      '<span class="rc-total-l">Total today</span>'
      +      '<span class="rc-total-v" id="drawerTotal">$0.00</span>'
      +     '</div>'
      +     '<p class="rc-note">Discount codes are applied at checkout</p>'
      +    '</div>'
      +    '<div class="rc-code" id="rcCode"></div>'
      +    '<p class="rc-thanks">★ Thank you for shopping ★</p>'
      +   '</div>'
      +  '</div>'
      + '</div>'
      + '<div class="rc-foot" id="drawerFooter">'
      +  '<form action="' + esc(action) + '" method="post" novalidate>'
      +   '<button type="submit" name="checkout" class="rc-checkout">Checkout →</button>'
      +  '</form>'
      +  '<button type="button" class="rc-continue" onclick="closeCartDrawer()">Continue shopping</button>'
      + '</div>';
  }

  function build() {
    var d = $('cartDrawer'), o = $('cartDrawerOverlay');
    if (!d) return false;
    if (d.getAttribute('data-rc')) return true;
    var f = d.querySelector('form'), action = (f && f.getAttribute('action')) || '/cart';
    var open = d.classList.contains('open');
    d.setAttribute('data-rc', '1');
    d.className = 'rc' + (open ? ' open' : '');
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-label', 'Your bag');
    d.innerHTML = shell(action);
    if (o) o.className = 'rc-overlay' + (open ? ' open' : '');
    return true;
  }

  function img(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=140'; }
  function q(key, n) { return "drawerQty('" + key + "'," + n + ')'; }

  function rowHTML(it) {
    var k = esc(it.key), v = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    return '<div class="rc-line" data-key="' + k + '">'
      + '<a class="rc-thumb" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" loading="lazy">' : '') + '</a>'
      + '<div class="rc-mid">'
      +  '<a class="rc-name" href="' + esc(it.url) + '"><span class="rc-q" data-qx>' + it.quantity + '×</span>' + esc(it.product_title) + '</a>'
      +  (v ? '<div class="rc-var">' + esc(v) + '</div>' : '')
      +  '<div class="rc-ctrl">'
      +   '<div class="rc-pill"><button type="button" aria-label="One less" onclick="' + q(k, it.quantity - 1) + '">−</button>'
      +   '<span data-qty>' + it.quantity + '</span>'
      +   '<button type="button" aria-label="One more" onclick="' + q(k, it.quantity + 1) + '">+</button></div>'
      +   '<button type="button" class="rc-rm" onclick="' + q(k, 0) + '">Remove</button>'
      +  '</div>'
      + '</div>'
      + '<div class="rc-amt" data-line>' + money(it.line_price) + '</div>'
      + '</div>';
  }

  function setQty(row, key, qty) {
    var a = row.querySelector('[data-qty]'), b = row.querySelector('[data-qx]'), btn = row.querySelectorAll('.rc-pill button');
    if (a) a.textContent = qty;
    if (b) b.textContent = qty + '×';
    if (btn[0]) btn[0].setAttribute('onclick', q(key, qty - 1));
    if (btn[1]) btn[1].setAttribute('onclick', q(key, qty + 1));
  }

  function setEmpty(is) {
    var p = $('rcPaper'), f = $('drawerFooter');
    if (p) p.classList.toggle('is-empty', !!is);
    if (f) f.style.display = is ? 'none' : '';
  }

  function paintTotals(cart) {
    var n = cart.item_count || 0;
    document.querySelectorAll('#cartCount,#drawerCount,#bottomNavCount').forEach(function (c) { c.textContent = n; });
    var s = $('drawerSubtotal'), t = $('drawerTotal');
    if (s) s.textContent = money(cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price);
    if (t) t.textContent = money(cart.total_price);
    setEmpty(n === 0);
    if (cart.token && cart.token !== state.token) {
      state.token = cart.token;
      var h = hash(cart.token), o = $('rcOrder'), c = $('rcCode');
      if (o) o.textContent = '#UL-' + ('00000' + (h % 1000000)).slice(-6);
      if (c) c.innerHTML = bars(h) + '<span class="rc-digits">' + digits(h) + '</span>';
    }
  }

  function render(cart) {
    var e = $('drawerItems'); if (!e) return;
    state.items = cart.items.slice();
    cart.items.forEach(function (it) { state.unit[it.key] = it.final_price != null ? it.final_price : it.price; });
    e.innerHTML = cart.items.map(rowHTML).join('');
    paintTotals(cart);
  }

  function leave(row) {
    row.classList.add('is-going');
    row.style.height = row.offsetHeight + 'px';
    requestAnimationFrame(function () { row.classList.add('is-gone'); });
    setTimeout(function () { if (row.parentNode) row.parentNode.removeChild(row); }, 420);
  }

  function patch(cart) {
    var e = $('drawerItems'); if (!e) return;
    var seen = {};
    cart.items.forEach(function (it) {
      seen[it.key] = true;
      state.unit[it.key] = it.final_price != null ? it.final_price : it.price;
      var row = e.querySelector('.rc-line[data-key="' + it.key + '"]');
      if (!row) return;
      if (state.want[it.key] === undefined || state.want[it.key] === it.quantity) {
        setQty(row, it.key, it.quantity);
        var p = row.querySelector('[data-line]'); if (p) p.textContent = money(it.line_price);
      }
    });
    [].slice.call(e.querySelectorAll('.rc-line')).forEach(function (row) {
      if (!seen[row.getAttribute('data-key')] && !row.classList.contains('is-going')) leave(row);
    });
    state.items = cart.items.slice();
    paintTotals(cart);
  }

  function sameLines(cart) {
    var e = $('drawerItems'); if (!e) return false;
    var rows = e.querySelectorAll('.rc-line:not(.is-going)');
    if (rows.length !== cart.items.length) return false;
    for (var i = 0; i < rows.length; i++) if (rows[i].getAttribute('data-key') !== cart.items[i].key) return false;
    return true;
  }

  /* feed the paper out of the slot, then stamp it */
  function print() {
    var p = $('rcPaper'), d = $('cartDrawer'); if (!p || !d) return;
    clearTimeout(printT);
    p.classList.remove('is-waiting', 'is-printing', 'is-stamped');
    if (reduce) { p.classList.add('is-stamped'); return; }
    void p.offsetWidth;
    p.classList.add('is-printing'); d.classList.add('rc-busy');
    printT = setTimeout(function () {
      d.classList.remove('rc-busy'); p.classList.remove('is-printing'); p.classList.add('is-stamped');
    }, 1550);
  }

  function load(fresh) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!$('drawerItems')) return;
        if (fresh || !sameLines(cart)) render(cart); else patch(cart);
      })
      .catch(function () {})
      .then(function () { if (fresh) setTimeout(print, 160); });
  }

  window.loadCartDrawer = function () { load(false); };

  window.openCartDrawer = function () {
    if (!build()) return;
    var d = $('cartDrawer'), o = $('cartDrawerOverlay'), p = $('rcPaper'), dt = $('rcDate'), sc = $('rcScroll');
    if (dt) dt.textContent = when(new Date());
    if (sc) sc.scrollTop = 0;
    if (p && !reduce) { clearTimeout(printT); p.classList.remove('is-printing', 'is-stamped'); p.classList.add('is-waiting'); }
    d.classList.add('open'); if (o) o.classList.add('open');
    document.body.classList.add('drawer-open');
    load(true);
  };

  window.closeCartDrawer = function () {
    var d = $('cartDrawer'), o = $('cartDrawerOverlay');
    if (d) d.classList.remove('open', 'rc-busy');
    if (o) o.classList.remove('open');
    document.body.classList.remove('drawer-open');
  };

  document.addEventListener('keydown', function (e) {
    var d = $('cartDrawer');
    if (e.key === 'Escape' && d && d.classList.contains('open')) window.closeCartDrawer();
  });

  function send(key) {
    var qty = state.want[key];
    state.inflight[key] = true;
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.inflight[key] = false;
        if (state.want[key] !== qty) { send(key); return; }
        delete state.want[key];
        if (cart && cart.items) patch(cart);
      })
      .catch(function () { state.inflight[key] = false; delete state.want[key]; load(false); });
  }

  window.drawerQty = function (key, qty) {
    qty = Math.max(0, qty | 0);
    var e = $('drawerItems'); if (!e) return;
    var row = e.querySelector('.rc-line[data-key="' + key + '"]');
    state.want[key] = qty;
    if (row) {
      if (qty === 0) leave(row);
      else {
        setQty(row, key, qty);
        var p = row.querySelector('[data-line]');
        if (p && state.unit[key] != null) p.textContent = money(state.unit[key] * qty);
      }
      var sum = 0, n = 0;
      [].slice.call(e.querySelectorAll('.rc-line:not(.is-going)')).forEach(function (r) {
        var k = r.getAttribute('data-key'), qq = parseInt(r.querySelector('[data-qty]').textContent, 10) || 0;
        if (state.unit[k] != null) sum += state.unit[k] * qq;
        n += qq;
      });
      var s = $('drawerSubtotal'), t = $('drawerTotal');
      if (s) s.textContent = money(sum);
      if (t) t.textContent = money(sum);
      document.querySelectorAll('#cartCount,#drawerCount,#bottomNavCount').forEach(function (c) { c.textContent = n; });
      if (n === 0) setEmpty(true);
    }
    if (!state.inflight[key]) send(key);
  };

  /* ---------- adding: a slip, not the whole bag ---------- */
  function slip(item) {
    var t = $('ulToast');
    if (!t) {
      t = document.createElement('div'); t.id = 'ulToast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
      t.innerHTML = '<span class="ulToast__n">Added</span><span class="ulToast__t"></span><button type="button" onclick="openCartDrawer()">View bag</button>';
      document.body.appendChild(t);
    }
    t.querySelector('.ulToast__t').textContent = (item && item.product_title) || '';
    t.classList.add('on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 3400);
  }
  function afterAdd(item) {
    if (window.refreshCartCount) refreshCartCount();
    if (window.pulseBagButtons) pulseBagButtons();
    var d = $('cartDrawer');
    if (d && d.classList.contains('open')) load(false);
    slip(item);
  }
  window.quickAdd = function (id, btn) {
    if (btn && btn.disabled) return;
    if (btn) { btn.disabled = true; btn.classList.add('adding'); btn.textContent = '...'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (btn) { btn.classList.remove('adding'); btn.classList.add('added'); btn.textContent = '✓ Added'; }
        afterAdd(item);
        if (btn) setTimeout(function () { btn.classList.remove('added'); btn.textContent = 'Add'; btn.disabled = false; }, 1600);
      })
      .catch(function () { if (btn) { btn.classList.remove('adding'); btn.textContent = 'Add'; btn.disabled = false; } });
  };
  window.qvAddToCart = function () {
    var vid = window.qvVariantId; if (!vid) return;
    var btn = $('qvAtc'); if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (btn) btn.textContent = '✓ Added';
        afterAdd(item);
        setTimeout(function () { if (window.closeQuickView) closeQuickView(); if (btn) { btn.textContent = 'Add to Bag →'; btn.disabled = false; } }, 700);
      })
      .catch(function () { if (btn) { btn.textContent = 'Add to Bag →'; btn.disabled = false; } });
  };

  if (!build()) document.addEventListener('DOMContentLoaded', build);
})();
